import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./ArtworkDetails.css";

// Normaliza cadenas eliminando caracteres especiales
function normalizeString(str) {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase();
}

function ArtworkDetails({ artworks }) {
  const { category, title } = useParams();

  // Normalizar categoría
  const normalizedCategory = Object.keys(artworks).find(
    (cat) => normalizeString(cat) === category
  );

  // Buscar la obra de arte
  const artwork =
    normalizedCategory &&
    artworks[normalizedCategory]?.find(
      (art) => normalizeString(art.title) === title
    );

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Mostrar "Category Not Found" si no se encuentra la categoría
  if (!normalizedCategory) {
    return (
      <div className="details-container">
        <h1>Category Not Found</h1>
        <Link to="/obras">← Go Back to Works</Link>
      </div>
    );
  }

  // Mostrar "Artwork Not Found" si no se encuentra la obra
  if (!artwork) {
    return (
      <div className="details-container">
        <h1>Artwork Not Found</h1>
        <Link to={`/obras/${category}`} className="back-link">
          ← Go Back to {normalizedCategory}
        </Link>
      </div>
    );
  }

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="details-container">
      <div className="details-box">
        <img
          src={artwork.image}
          alt={artwork.title}
          className="details-image"
          onClick={openModal} // Abre el modal al hacer clic en la imagen
        />
        <div className="details-info">
          <h1 className="details-title">{artwork.title}</h1>
          <p className="details-year">{artwork.year}</p>
          <p className="details-dimensions">{artwork.dimensions}</p>
          <p className="details-description">{artwork.description}</p>
          <Link to={`/obras/${category}`} className="back-link">
            ← Volver a {normalizedCategory}
          </Link>
        </div>
      </div>

    
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content">
            <img
              src={artwork.image}
              alt={artwork.title}
              className="modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ArtworkDetails;